import { ERP } from '../_base/endpoint';
import axios from 'axios';

import global from '../../common/utility/global';

class centroCostoService {

    /******* QUERIES ******/

    async listar() {
        const response = await axios
            .get(`${ERP}tesoreria/centro-costo`)
            .then(response => {
                return response.data;
            })
            .catch(error => {
                console.log(error);
            });
        return response;
    };

    async listarPorIdEstablecimiento(idEstablecimiento) {
        const response = await axios
            .get(`${ERP}tesoreria/centro-costo/por-establecimiento/${idEstablecimiento}`)
            .then(response => {
                return response.data;
            })
            .catch(error => {
                console.log(error);
            });
        return response;
    };

    async paginacion(filter) {
        const response = await axios
            .get(`${ERP}tesoreria/centro-costo/paginacion?${global.formatParameter(filter)}`)
            .then(response => {
                return response.data;
            })
            .catch(error => {
                console.log(error);
            });
        return response;
    };

    async obtenerPorId(id) {
        const response = await axios
            .get(`${ERP}tesoreria/centro-costo/${id}`)
            .then(response => {
                return response.data;
            })
            .catch(error => {
                console.log(error);
            });
        return response;
    };

    async excel(filter) {
        const response = await axios
            .get(`${ERP}tesoreria/centro-costo/excel?${global.formatParameter(filter)}`, { responseType: 'blob', })
            .then(response => {
                return response;
            })
            .catch(error => {
                console.log(error);
            });
        return response;
    };

    async pdf(filter) {
        const response = await axios
            .get(`${ERP}tesoreria/centro-costo/pdf?${global.formatParameter(filter)}`, { responseType: 'blob', })
            .then(response => {
                return response;
            })
            .catch(error => {
                console.log(error);
            });
        return response;
    };

    /******* TRANSACCIONES ******/

    async registrar(data) {
        const response = await axios
            .post(`${ERP}tesoreria/centro-costo`, data)
            .then(response => {
                return response;
            })
            .catch(error => {
                console.log(error);
                return error.response ? error.response : {};
            });
        return response;
    };

    async modificar(data) {
        const response = await axios
            .put(`${ERP}tesoreria/centro-costo`, data)
            .then(response => {
                return response;
            })
            .catch(error => {
                console.log(error);
                return error.response ? error.response : {};
            });
        return response;
    };

    async eliminar(data) {
        const response = await axios
            .put(`${ERP}tesoreria/centro-costo/eliminar`, data)
            .then(response => {
                return response;
            })
            .catch(error => {
                console.log(error);
                return error.response ? error.response : {};
            });
        return response;
    };

    async activar(data) {
        const response = await axios
            .put(`${ERP}tesoreria/centro-costo/activar`, data)
            .then(response => {
                return response;
            })
            .catch(error => {
                console.log(error);
                return error.response ? error.response : {};
            });
        return response;
    };
}

export default new centroCostoService();